import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
  inject,
} from '@angular/core';
import { KeeniconComponent, LoaderComponent } from '../../partials';
import {
  AvatarDirective,
  MODAL_CONFIG,
  UploadImageService,
  USER_DEFAULT_AVATAR,
} from '@core-utils';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from '../../modals';

@Component({
  selector: 'ui-avatar',
  imports: [KeeniconComponent, LoaderComponent, AvatarDirective],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [UploadImageService],
})
export class AvatarComponent {
  private uploadImageService = inject(UploadImageService);
  private modalService = inject(NgbModal);

  image = model<string | null | undefined>();
  class = input<string>('me-6');
  modalClearImageTitle = input<string>('');
  modalClearImageDescription = input<string>('');
  isLoading = input<boolean>(false);
  changeImage = output<File | null>();

  onFileSelected(event: Event) {
    const { file, fileUrl } =
      this.uploadImageService.handleFileSelection(event);
    if (file && fileUrl) {
      this.image.set(fileUrl);
      this.changeImage.emit(file);
    }
  }

  removeImage() {
    const modalRef = this.modalService.open(
      ConfirmModalComponent,
      MODAL_CONFIG,
    );
    modalRef.componentInstance.title.set(this.modalClearImageTitle());
    modalRef.componentInstance.description.set(
      this.modalClearImageDescription(),
    );
    modalRef.result.then((result) => {
      if (result) {
        this.image.set(USER_DEFAULT_AVATAR);
        this.changeImage.emit(null);
      }
    });
  }
}
